exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.modal-dialog.modal-md[data-v-df91e586] {\n    margin: 12% auto;\n}\n.modal-dialog.modal-xlg[data-v-df91e586] {\n    width: 1300px;\n}\n.modal[data-v-df91e586] {\n    background: #313541d1;\n    overflow-y: auto;\n}\n.close[data-v-df91e586] {\n    position: absolute;\n    right: -35px;\n}\n.modal-footer[data-v-df91e586] {\n    margin-top: 10px;\n}\n.show-enter-active[data-v-df91e586],\n.show-leave-active[data-v-df91e586] {\n    transition: all 0.25s;\n}\n.show-enter[data-v-df91e586],\n.show-leave-to[data-v-df91e586] {\n    transform: translateY(20px);\n    opacity: 0;\n}\n.d-block[data-v-df91e586] {\n    display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-df91e586&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/v-components/modal.vue
// module id = 87
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 34 35 36 37 38 39 40 41 42